import { render, staticRenderFns } from "./UserParentsList.vue?vue&type=template&id=16726481&"
import script from "./UserParentsList.vue?vue&type=script&lang=js&"
export * from "./UserParentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports